module.exports = __webpack_public_path__ + "img/icon02_highlight.663ae18.png";